(function () {
  'use strict';

  var hoverQuery = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;

  function annotateRevealKinds(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-escosy-reveal]').forEach(function (node) {
      if (node.dataset.escosyReveal) return;

      if (node.closest('.escosy-hero')) {
        node.dataset.escosyReveal = 'hero';
      } else if (node.matches('.escosy-use-card, .escosy-mode-card')) {
        node.dataset.escosyReveal = 'card';
      } else if (node.matches('.escosy-media')) {
        node.dataset.escosyReveal = 'media';
      } else {
        node.dataset.escosyReveal = 'copy';
      }
    });
  }

  function revealImmediately(node) {
    node.dataset.escosyRevealReady = 'true';
    if (window.EscosyReveal) {
      window.EscosyReveal.reveal(node);
    } else {
      node.classList.add('is-visible');
    }
  }

  function initReveals(root) {
    var scope = root && root.querySelectorAll ? root : document;
    annotateRevealKinds(scope);
    var sharedReveal = window.EscosyReveal;

    scope.querySelectorAll('[data-escosy-reveal]:not([data-escosy-reveal-ready])').forEach(function (node) {
      if (node.dataset.escosyReveal === 'hero') {
        node.dataset.escosyRevealReady = 'true';
        node.classList.add('is-visible');
        return;
      }

      if (!sharedReveal) {
        revealImmediately(node);
        return;
      }

      node.dataset.escosyRevealReady = 'true';
      node.classList.add('escosy-reveal-ready');
      sharedReveal.observe(node);
    });
  }

  function cleanupReveals(root) {
    if (window.EscosyReveal) window.EscosyReveal.cleanup(root);
  }

  function initDisclosureGroups(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-escosy-disclosure-group]:not([data-escosy-disclosure-ready])').forEach(function (group) {
      group.dataset.escosyDisclosureReady = 'true';
      group.addEventListener('toggle', function (event) {
        var opened = event.target;
        if (opened.tagName !== 'DETAILS' || !opened.open) return;
        group.querySelectorAll('details[open]').forEach(function (item) {
          if (item !== opened) item.removeAttribute('open');
        });
      }, true);
    });
  }

  function initAnatomy(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.escosy-anatomy__layout:not([data-escosy-anatomy-ready])').forEach(function (layout) {
      var hotspots = Array.prototype.slice.call(layout.querySelectorAll('.escosy-hotspot'));
      var notes = Array.prototype.slice.call(layout.querySelectorAll('.escosy-anatomy__note'));
      if (!hotspots.length || !notes.length) return;

      layout.dataset.escosyAnatomyReady = 'true';
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var listenerOptions = controller ? { signal: controller.signal } : false;
      layout._escosyAnatomyController = controller;

      function setPreview(index, preview) {
        if (!hotspots[index] || !notes[index]) return;
        hotspots[index].classList.toggle('is-preview', preview);
        notes[index].classList.toggle('is-preview', preview);
      }

      function syncActive() {
        hotspots.forEach(function (hotspot, index) {
          var active = hotspot.open;
          hotspot.classList.toggle('is-active', active);
          if (notes[index]) notes[index].classList.toggle('is-active', active);
        });
      }

      hotspots.forEach(function (hotspot, index) {
        hotspot.dataset.escosyAnatomyIndex = String(index);
        if (notes[index]) notes[index].dataset.escosyAnatomyIndex = String(index);

        hotspot.addEventListener('toggle', syncActive, listenerOptions);
        var summary = hotspot.querySelector('summary');
        if (summary) {
          summary.addEventListener('focusin', function () { setPreview(index, true); }, listenerOptions);
          summary.addEventListener('focusout', function () { setPreview(index, false); }, listenerOptions);
        }

        if (hoverQuery && hoverQuery.matches && notes[index]) {
          notes[index].addEventListener('pointerenter', function () { setPreview(index, true); }, listenerOptions);
          notes[index].addEventListener('pointerleave', function () { setPreview(index, false); }, listenerOptions);
        }
      });

      syncActive();
    });
  }

  function cleanupAnatomy(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.escosy-anatomy__layout[data-escosy-anatomy-ready]').forEach(function (layout) {
      if (layout._escosyAnatomyController) layout._escosyAnatomyController.abort();
      delete layout._escosyAnatomyController;
    });
  }

  function computeCoverRect(stageWidth, stageHeight, sourceWidth, sourceHeight, focusX, focusY) {
    if (
      !Number.isFinite(stageWidth)
      || !Number.isFinite(stageHeight)
      || !Number.isFinite(sourceWidth)
      || !Number.isFinite(sourceHeight)
      || stageWidth <= 0
      || stageHeight <= 0
      || sourceWidth <= 0
      || sourceHeight <= 0
    ) return null;

    var resolvedFocusX = Number.isFinite(focusX) ? Math.min(1, Math.max(0, focusX)) : 0.5;
    var resolvedFocusY = Number.isFinite(focusY) ? Math.min(1, Math.max(0, focusY)) : 0.5;
    var scale = Math.max(stageWidth / sourceWidth, stageHeight / sourceHeight);
    var width = sourceWidth * scale;
    var height = sourceHeight * scale;

    return {
      left: (stageWidth - width) * resolvedFocusX,
      top: (stageHeight - height) * resolvedFocusY,
      width: width,
      height: height
    };
  }

  window.EscosyHomeGeometry = {
    computeCoverRect: computeCoverRect
  };

  function comfortSectionsWithin(root, initialized) {
    var scope = root && root.querySelectorAll ? root : document;
    var selector = initialized
      ? '[data-escosy-comfort-layers][data-escosy-layers-ready]'
      : '[data-escosy-comfort-layers]:not([data-escosy-layers-ready])';
    var sections = [];

    if (scope.matches && scope.matches(selector)) sections.push(scope);
    scope.querySelectorAll(selector).forEach(function (section) {
      sections.push(section);
    });

    return sections;
  }

  function initComfortLayers(root) {
    comfortSectionsWithin(root, false).forEach(function (section) {
      var stage = section.querySelector('[data-escosy-layer-stage]');
      var map = stage ? stage.querySelector('[data-escosy-layer-map]') : null;
      var media = stage ? stage.querySelector('video, img') : null;
      var controlsGroup = section.querySelector('[data-escosy-layer-controls]');
      var fallback = section.querySelector('[data-escosy-layer-fallback]');
      var sentinel = section.querySelector('[data-escosy-feature-center]');
      var controls = Array.prototype.slice.call(section.querySelectorAll('[data-escosy-layer-control]'));
      var layers = Array.prototype.slice.call(section.querySelectorAll('[data-escosy-comfort-layer]'));
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-escosy-layer-card]'));
      var phaseLabels = Array.prototype.slice.call(section.querySelectorAll('[data-escosy-phase-label]'));
      if (!stage || !map || !controlsGroup || !controls.length || !layers.length) return;

      section.dataset.escosyLayersReady = 'true';
      section.dataset.phase = 'idle';
      section.dataset.selectedLayer = 'all';

      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var fallbackRemovers = [];
      var isEnhanced = false;
      var resizeObserver = null;
      var featureObserver = null;
      var featureObserverViewportHeight = 0;
      var geometryFrame = 0;
      var geometryKey = '';
      var compositionTimers = [];
      var replayTimer = 0;
      var replayLayer = null;
      var selectedLayer = 'all';
      var previewLayer = null;
      var editorLayer = '';
      var motionQuery = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : null;

      function listen(target, eventName, handler, options) {
        if (!target || !target.addEventListener) return;
        var listenerOptions = options || false;

        if (controller) {
          if (listenerOptions === false) {
            listenerOptions = { signal: controller.signal };
          } else {
            listenerOptions = Object.assign({}, listenerOptions, { signal: controller.signal });
          }
        }

        target.addEventListener(eventName, handler, listenerOptions);
        if (!controller) {
          fallbackRemovers.push(function () {
            target.removeEventListener(eventName, handler, listenerOptions);
          });
        }
      }

      function listenForMotionChange(handler) {
        if (!motionQuery) return;
        if (motionQuery.addEventListener) {
          listen(motionQuery, 'change', handler);
          return;
        }
        if (!motionQuery.addListener) return;
        motionQuery.addListener(handler);
        fallbackRemovers.push(function () {
          motionQuery.removeListener(handler);
        });
      }

      function layerExists(layerId) {
        return layers.some(function (layer) {
          return layer.dataset.escosyComfortLayer === layerId;
        });
      }

      function layerType(layer) {
        if (layer.dataset.escosyLayerType) return layer.dataset.escosyLayerType;
        if (layer.classList.contains('escosy-comfort-layer--heat')) return 'heat';
        if (layer.classList.contains('escosy-comfort-layer--vibration')) return 'vibration';
        if (layer.classList.contains('escosy-comfort-layer--support')) return 'support';
        return '';
      }

      function controlLayer(control) {
        var layerId = control.dataset.escosyLayerControl || '';
        return layerId === 'all' || layerExists(layerId) ? layerId : '';
      }

      function motionEnabled() {
        if (window.EscosyReveal) return window.EscosyReveal.enabled();
        return document.documentElement.classList.contains('es-motion-enabled')
          && !(motionQuery && motionQuery.matches);
      }

      function setActiveStep(step) {
        if (step) {
          section.dataset.activeStep = step;
        } else {
          delete section.dataset.activeStep;
        }
        phaseLabels.forEach(function (label) {
          label.classList.toggle('is-active', label.dataset.escosyPhaseLabel === step);
        });
      }

      function enhance() {
        if (isEnhanced) return;
        isEnhanced = true;
        section.classList.add('is-enhanced');
        controlsGroup.hidden = false;
        controlsGroup.removeAttribute('inert');
        if (fallback) fallback.hidden = true;
      }

      function paint() {
        var layerId = editorLayer || (previewLayer !== null ? previewLayer : selectedLayer);
        if (layerId !== 'all' && !layerExists(layerId)) layerId = 'all';
        var hasActiveLayer = layerId !== 'all';

        section.dataset.selectedLayer = selectedLayer;
        if (previewLayer !== null) {
          section.dataset.previewLayer = previewLayer;
        } else {
          delete section.dataset.previewLayer;
        }

        layers.forEach(function (layer) {
          var isActiveLayer = layer.dataset.escosyComfortLayer === layerId;
          layer.classList.toggle('is-active', isActiveLayer);
          layer.classList.toggle('is-muted', hasActiveLayer && !isActiveLayer);
        });
        cards.forEach(function (card) {
          var isActiveCard = card.dataset.escosyLayerCard === layerId;
          card.classList.toggle('is-active', isActiveCard);
          card.classList.toggle('is-muted', hasActiveLayer && !isActiveCard);
        });
        controls.forEach(function (control) {
          var controlId = controlLayer(control);
          control.classList.toggle('is-active', controlId === layerId);
          control.setAttribute('aria-pressed', controlId === selectedLayer ? 'true' : 'false');
        });
      }

      function clearCompositionTimers() {
        compositionTimers.forEach(function (timer) {
          window.clearTimeout(timer);
        });
        compositionTimers = [];
      }

      function queueComposition(callback, delay) {
        compositionTimers.push(window.setTimeout(callback, delay));
      }

      function disconnectFeatureObserver() {
        if (!featureObserver) return;
        featureObserver.disconnect();
        featureObserver = null;
        featureObserverViewportHeight = 0;
      }

      function clearReplay() {
        if (replayTimer) window.clearTimeout(replayTimer);
        replayTimer = 0;
        if (replayLayer) replayLayer.classList.remove('is-replaying');
        replayLayer = null;
        delete section.dataset.replayLayer;
      }

      function finishComposition(phase) {
        clearCompositionTimers();
        clearReplay();
        disconnectFeatureObserver();
        selectedLayer = 'all';
        previewLayer = null;
        setActiveStep('');
        section.dataset.phase = phase || 'ready';
        section.dataset.hasPlayed = 'true';
        paint();
      }

      function interruptComposition() {
        if (
          section.dataset.phase === 'idle'
          || section.dataset.phase === 'composing'
        ) {
          finishComposition(motionEnabled() ? 'ready' : 'static');
        } else {
          disconnectFeatureObserver();
          section.dataset.hasPlayed = 'true';
        }
      }

      function beginComposition() {
        disconnectFeatureObserver();
        if (document.hidden || !motionEnabled()) {
          finishComposition('static');
          return;
        }

        clearCompositionTimers();
        clearReplay();
        selectedLayer = 'all';
        previewLayer = null;
        section.dataset.phase = 'composing';
        setActiveStep('heat');
        paint();

        queueComposition(function () { setActiveStep('vibration'); }, 520);
        queueComposition(function () { setActiveStep('support'); }, 1050);
        queueComposition(function () { setActiveStep('all'); }, 1720);
        queueComposition(function () { finishComposition('ready'); }, 2300);
      }

      function replaySelectedLayer(layerId) {
        if (!motionEnabled() || !layerExists(layerId)) return;
        clearReplay();

        replayLayer = layers.find(function (layer) {
          return layer.dataset.escosyComfortLayer === layerId;
        }) || null;
        if (!replayLayer) return;

        section.dataset.replayLayer = layerType(replayLayer);
        replayLayer.classList.remove('is-replaying');
        void replayLayer.offsetWidth;
        replayLayer.classList.add('is-replaying');
        replayTimer = window.setTimeout(clearReplay, 650);
      }

      function preview(control) {
        interruptComposition();
        clearReplay();
        var layerId = controlLayer(control);
        previewLayer = layerId;
        paint();
      }

      function restoreSelection() {
        previewLayer = null;
        paint();
      }

      function sourceDimensions() {
        var width = Number.parseFloat(stage.dataset.escosySourceWidth) || 0;
        var height = Number.parseFloat(stage.dataset.escosySourceHeight) || 0;

        if (media && media.tagName === 'IMG' && media.naturalWidth && media.naturalHeight) {
          width = media.naturalWidth;
          height = media.naturalHeight;
        } else if (media && media.tagName === 'VIDEO' && media.videoWidth && media.videoHeight) {
          width = media.videoWidth;
          height = media.videoHeight;
        }

        return { width: width, height: height };
      }

      function armFeatureObserver() {
        var viewportHeight = Math.max(1, Math.round(window.innerHeight));

        if (
          featureObserver
          && featureObserverViewportHeight !== viewportHeight
        ) disconnectFeatureObserver();

        if (
          featureObserver
          || section.dataset.hasPlayed
          || section.dataset.phase !== 'idle'
        ) return;

        if (!motionEnabled() || !sentinel || !('IntersectionObserver' in window)) {
          finishComposition('static');
          return;
        }

        if (sentinel.getBoundingClientRect().bottom < 0) {
          finishComposition('static');
          return;
        }

        featureObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) beginComposition();
          });
        }, {
          rootMargin: '0px 0px -' + Math.round(viewportHeight * 0.28) + 'px 0px',
          threshold: 0
        });
        featureObserverViewportHeight = viewportHeight;
        featureObserver.observe(sentinel);
      }

      function positionMap() {
        geometryFrame = 0;
        var source = sourceDimensions();
        var rect = computeCoverRect(
          stage.clientWidth,
          stage.clientHeight,
          source.width,
          source.height,
          Number.parseFloat(stage.dataset.escosyFocusX),
          Number.parseFloat(stage.dataset.escosyFocusY)
        );

        if (!rect) {
          stage.removeAttribute('data-escosy-geometry-ready');
          return;
        }

        var nextKey = [
          rect.left.toFixed(3),
          rect.top.toFixed(3),
          rect.width.toFixed(3),
          rect.height.toFixed(3)
        ].join(':');

        if (nextKey !== geometryKey) {
          geometryKey = nextKey;
          map.style.left = rect.left + 'px';
          map.style.top = rect.top + 'px';
          map.style.width = rect.width + 'px';
          map.style.height = rect.height + 'px';
        }

        stage.setAttribute('data-escosy-geometry-ready', 'true');
        armFeatureObserver();
        enhance();
      }

      function scheduleGeometry() {
        if (geometryFrame) return;
        geometryFrame = window.requestAnimationFrame(positionMap);
      }

      function selectLayer(control) {
        var layerId = controlLayer(control);
        if (!layerId) return;

        interruptComposition();
        clearReplay();
        previewLayer = null;
        selectedLayer = layerId;
        section.dataset.phase = motionEnabled() ? 'ready' : 'static';
        setActiveStep('');
        paint();
        if (layerId !== 'all') replaySelectedLayer(layerId);
      }

      controls.forEach(function (control) {
        if (hoverQuery && hoverQuery.matches) {
          listen(control, 'pointerenter', function () {
            if (section.dataset.phase === 'composing') return;
            preview(control);
          });
          listen(control, 'pointermove', function () {
            if (section.dataset.phase === 'composing') preview(control);
          }, { passive: true });
          listen(control, 'pointerleave', restoreSelection);
        }
        listen(control, 'focusin', function () { preview(control); });
        listen(control, 'focusout', restoreSelection);
        listen(control, 'click', function () { selectLayer(control); });
      });

      listen(section, 'shopify:block:select', function (event) {
        var blockId = event.detail && event.detail.blockId
          ? String(event.detail.blockId)
          : '';
        var card = cards.find(function (item) {
          return item.dataset.escosyBlockId === blockId;
        });

        if (!card && event.target && event.target.closest) {
          card = event.target.closest('[data-escosy-layer-card]');
        }

        var layerId = card && section.contains(card)
          ? card.dataset.escosyLayerCard || ''
          : '';
        editorLayer = layerExists(layerId) ? layerId : '';
        interruptComposition();
        paint();
      });

      listen(section, 'shopify:block:deselect', function () {
        editorLayer = '';
        paint();
      });

      listen(section, 'animationend', function (event) {
        if (
          section.dataset.phase === 'composing'
          && event.animationName === 'escosy-compose-together'
        ) {
          finishComposition('ready');
          return;
        }

        if (
          replayLayer
          && (
            event.animationName === 'escosy-manual-heat'
            || event.animationName === 'escosy-manual-vibration'
            || event.animationName === 'escosy-manual-support'
          )
        ) clearReplay();
      });

      function handlePageHidden() {
        if (section.dataset.phase === 'composing') {
          finishComposition('static');
        } else {
          clearReplay();
        }
      }

      listen(document, 'visibilitychange', function () {
        if (document.hidden) handlePageHidden();
      });
      listen(window, 'pagehide', handlePageHidden);

      listenForMotionChange(function () {
        if (!motionEnabled()) {
          finishComposition('static');
        } else if (!section.dataset.hasPlayed && section.dataset.phase === 'idle') {
          armFeatureObserver();
        }
      });

      if (media) {
        if (media.tagName === 'IMG') {
          listen(media, 'load', scheduleGeometry);
        } else if (media.tagName === 'VIDEO') {
          listen(media, 'loadedmetadata', scheduleGeometry);
        }
      }

      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(scheduleGeometry);
        resizeObserver.observe(stage);
      }
      listen(window, 'resize', scheduleGeometry, { passive: true });

      scheduleGeometry();
      paint();
      if (!motionEnabled()) finishComposition('static');

      section._escosyLayersCleanup = function () {
        if (controller) controller.abort();
        fallbackRemovers.forEach(function (removeListener) {
          removeListener();
        });
        if (resizeObserver) resizeObserver.disconnect();
        disconnectFeatureObserver();
        clearCompositionTimers();
        clearReplay();
        if (geometryFrame) window.cancelAnimationFrame(geometryFrame);

        if (isEnhanced) {
          controlsGroup.hidden = true;
          controlsGroup.setAttribute('inert', '');
          if (fallback) fallback.hidden = false;
        }
        section.classList.remove('is-enhanced');
        map.style.removeProperty('left');
        map.style.removeProperty('top');
        map.style.removeProperty('width');
        map.style.removeProperty('height');
        stage.removeAttribute('data-escosy-geometry-ready');
        delete section.dataset.phase;
        delete section.dataset.selectedLayer;
        delete section.dataset.previewLayer;
        delete section.dataset.activeStep;
        delete section.dataset.hasPlayed;
        layers.forEach(function (layer) {
          layer.classList.remove('is-active', 'is-muted', 'is-replaying');
        });
        cards.forEach(function (card) {
          card.classList.remove('is-active', 'is-muted');
        });
        controls.forEach(function (control) {
          control.classList.remove('is-active');
          control.setAttribute('aria-pressed', 'false');
        });
        delete section.dataset.escosyLayersReady;
        delete section._escosyLayersCleanup;
      };
    });
  }

  function cleanupComfortLayers(root) {
    comfortSectionsWithin(root, true).forEach(function (section) {
      if (section._escosyLayersCleanup) section._escosyLayersCleanup();
    });
  }

  function init(root) {
    initDisclosureGroups(root);
    initAnatomy(root);
    initComfortLayers(root);
    initReveals(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupReveals(event.target);
    cleanupAnatomy(event.target);
    cleanupComfortLayers(event.target);
  });
})();
